import { Injectable } from '@angular/core';
import { ServiceActivity, ServiceActivityAS, ServiceActivityDTO } from '../../models/serviceactivity.interface';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { RequestService } from '../request/request';
import { AsyncFormValidation } from '../../interceptors/error.interceptor';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Pagination } from '../../models/pagination.interface';
import { QueryGet } from '../../types/query-types';
import { OptionSelect } from '../../../shared/components/search-select/search-select';

@Injectable({
  providedIn: 'root',
})
export class ServiceactivityService {
  httpOptions = {
    headers: new HttpHeaders({}),
  };

  urlPath = environment.service_1 + 'service-activities/';
  url = environment.service_1 + 'all-service-activities/';

  public asyncErrorValidation = new BehaviorSubject<AsyncFormValidation | null>(null);
  asyncErrorValidation$ = this.asyncErrorValidation.asObservable();

  private selectedServiceActivity = new BehaviorSubject<ServiceActivity | null>(null);
  selectedServiceActivity$ = this.selectedServiceActivity.asObservable();

  private serviceActivityes = new BehaviorSubject<ServiceActivity[]>([]);
  serviceActivityes$ = this.serviceActivityes.asObservable();

  constructor(
    private http: HttpClient,
    private requestService: RequestService,
  ) {}

  setServiceActivity(serviceActivity: ServiceActivity) {
    this.selectedServiceActivity.next(serviceActivity);
  }

  setServiceActivities(serviceActivityes: ServiceActivity[]) {
    this.serviceActivityes.next(serviceActivityes);
  }

  removeServiceActivitySelected() {
    this.selectedServiceActivity.next(null);
  }

  createServiceActivity(serviceActivity: ServiceActivityDTO) {
    return this.http.post<ServiceActivity>(this.urlPath, serviceActivity).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  updateServiceActivity(id: number, serviceActivity: ServiceActivityDTO & { id: number }) {
    return this.http.put<ServiceActivity>(this.urlPath + id + '/', serviceActivity).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  getServiceActivity(query: QueryGet): Observable<Pagination<ServiceActivity[]>> {
    return this.requestService.get<ServiceActivity[]>(this.urlPath, query);
  }

    getById(id: number): Observable<ServiceActivityAS> {
      return this.http.get<ServiceActivityAS>(`${this.urlPath}${id}/`);
    }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(this.urlPath + id + '/');
  }

  getServiceActivities(): Observable<ServiceActivity[]> {
    return this.http.get<ServiceActivity[]>(this.url, {
      headers: this.httpOptions.headers,
    });
  }

  getOptionServiceActivity(component: ServiceActivity[]): OptionSelect[] {
    return component.map((item: ServiceActivity) => {
      return {
        value: item.id ?? '',
        label: item.name,
      };
    });
  }
}
